import React from "react";

export default function Navbar(props) {
  return (
    <div className="navbar bg-[#FBFDFD] absolute">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={0}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            <li>
              <a className="" href="/">Home</a>
            </li>
            {/* <li>
              <a>Item 2</a>
            </li>
            <li>
              <a>Item 3</a>
            </li> */}
          </ul>
        </div>
        <a href="/" className="text-main text-[#031926] btn btn-ghost normal-case text-xl">PizzArte</a>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal p-0">
          <li>
            <a className="text-base-100" href="/">Home</a>
          </li>
          {/* <li>
            <a>Item 2</a>
          </li>
          <li>
            <a>Item 3</a>
          </li> */}
        </ul>
      </div>
      <div className="navbar-end">
        <a 
          className="btn"
          href={require("../../components/utilities/images/pizzarte_menu.pdf")}
          download="pizzarte_menu"
        >
          Download Menu
        </a>
      </div>
    </div>
  );
}
